/**
 * Builds the redirect link used when a candidate/stage cell on a job card is
 * clicked.
 *
 * Any job that can hold applications — i.e. anything past the `draft` state
 * (published, closed, archived, scheduled, pending_approval, rejected) — should
 * deep-link into the candidates tab, filtered by the clicked stage. `draft`
 * jobs have no pipeline yet, so they fall back to the plain job page (matching
 * how the card header link treats drafts).
 *
 * Previously this only fired for `published` jobs, which is why clicking a
 * candidate/stage cell on a *closed* job card failed to open the candidates
 * page (ENG-3336).
 */
export const buildJobCardRedirectLink = (
  state: string | undefined,
  jobId: string | number,
  navigationStageId: string | number
): string => {
  const hasCandidatePipeline = state !== 'draft';
  const query = hasCandidatePipeline
    ? `?stageId=${navigationStageId}&tab=candidates`
    : '';
  return `/jobs/${jobId}${query}`;
};
